/* eslint-disable @repo/internal/react/require-jsdoc */
/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { css, jsx } from '@compiled/react';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

const rootStyles = xcss({
	paddingBlock: 'space.500',
});

const videoStyles = css({
	width: '100%',
	minWidth: '0',
	border: 'none',
	borderRadius: token('radius.xlarge'),
});

export const Video = ({ src }: { src: string }) => {
	return (
		<Flex xcss={rootStyles} justifyContent="center">
			<iframe
				css={videoStyles}
				width="560"
				height="315"
				src={`${src}?rel=0&modestbranding=1`} // Hide related videos and YouTube logo
				title="YouTube video player"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
				referrerPolicy="strict-origin-when-cross-origin"
				allowFullScreen
			></iframe>
		</Flex>
	);
};
